import { adList } from "@/api/website"
import { floors, floatLayer, apiDefaultSearchWords } from "@/api/pc"
import { mapGetters } from "vuex"
import { couponList, receiveCoupon } from "@/api/coupon"
import { goodsPage, timeList } from "@/api/seckill"
import { exchangePage } from "@/api/exchange"
import CountDown from "vue2-countdown"

export default {
    name: "index",
    components: {
        CountDown
    },
    data: () => {
        return {
            loadingAd: true,
            loadingFloor: true,
            adList: [],
            adLeftList: [],
            adRightList: [],
            couponList: [],
            floorList: [],
            floatLayer: {
                is_show: false,
                link: {
                    url: ""
                }
            },
            indexFloatLayerNum: 0,
            isSub: false,
            siteId: 0,
            listData: [],
            exchangelistData: [],
            seckillTimeMachine: {
                currentTime: 0,
                startTime: 0,
                endTime: 0
            },
            seckillText: "距离结束",
            backgroundColor: "", // 顶部banner背景颜色
            // 悬浮搜索
            searchType: "goods",
            searchTypeText: "商品",
            keyword: "",
            defaultSearchWords: "",
            isShow: false
        }
    },
    watch: {
        token(newVal, oldVal) {
            // 退出登录刷新换购和秒杀专区 组件不更新状态
            this.$refs.seckillRef.reset()
            this.$refs.exchangeRef.reset()
        },
        searchType() {
            this.searchTypeText = this.searchType == "goods" ? "商品" : "店铺"
        }
    },
    created() {
        this.getAdList()
        this.getBigAdList()
        this.getSmallAdList()
        this.getFloors()
        this.getFloatLayer()
        this.$store.dispatch("site/siteInfo") // 站点信息
        this.getDefaultSearchWords() // 默认搜索类型
        if (this.addonIsExit && this.addonIsExit.seckill == 1) {
            this.getTimeList()
        }
        this.getCanReceiveCouponQuery()
        this.exchange()
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
    },
    computed: {
        ...mapGetters(["token", "defaultHeadImage", "addonIsExit", "defaultGoodsImage", "member", "siteInfo", "cartCount"]),
        optionLeft() {
            return {
                direction: 2,
                limitMoveNum: 2
            }
        }
    },
    methods: {
        countDownS_cb() {},
        countDownE_cb() {
            this.seckillText = "活动已结束"
        },
        getAdList() {
            adList({
                keyword: "NS_PC_INDEX"
            })
                .then((res) => {
                    this.adList = res.data.adv_list
                    for (let i = 0; i < this.adList.length; i++) {
                        if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url)
                    }
                    this.backgroundColor = this.adList[0].background
                    this.loadingAd = false
                })
                .catch((err) => {
                    this.loadingAd = false
                })
        },
        handleChange(curr, pre) {
            this.backgroundColor = this.adList[curr].background
        },
        /**
         * 广告位大图
         */
        getBigAdList() {
            adList({
                keyword: "NS_PC_INDEX_MID_LEFT"
            })
                .then((res) => {
                    this.adLeftList = res.data.adv_list
                    for (let i = 0; i < this.adLeftList.length; i++) {
                        if (this.adLeftList[i].adv_url) this.adLeftList[i].adv_url = JSON.parse(this.adLeftList[i].adv_url)
                    }
                    this.loadingAd = false
                })
                .catch((err) => {
                    this.loadingAd = false
                })
        },
        /**
         * 广告位小图
         */
        getSmallAdList() {
            adList({
                keyword: "NS_PC_INDEX_MID_RIGHT"
            })
                .then((res) => {
                    this.adRightList = res.data.adv_list
                    for (let i = 0; i < this.adRightList.length; i++) {
                        if (this.adRightList[i].adv_url) this.adRightList[i].adv_url = JSON.parse(this.adRightList[i].adv_url)
                    }
                    this.loadingAd = false
                })
                .catch((err) => {
                    this.loadingAd = false
                })
        },
        //获取优惠券列表
        getCanReceiveCouponQuery() {
            couponList({
                activeName: "second",
                site_id: this.siteId
            })
                .then((res) => {
                    let data = res.data
                    this.couponList = []
                    if (data != null) {
                        for (let i = 0; i < data.list.length; i++) {
                            if (i < data.list.length) {
                                this.couponList.push(data.list[i])
                            }
                        }
                    }
                    this.couponList = this.couponList.filter((item) => item.useState !== 3).slice(0, 4)
                })
                .catch((err) => {})
        },
        /**
         * 领取优惠券
         */
        receiveCoupon(item, index) {
            if (this.isSub) return
            this.isSub = true

            var data = {
                site_id: item.site_id,
                activeName: "second",
                coupon_type_id: item.coupon_type_id
            }
            receiveCoupon(data)
                .then((res) => {
                    var data = res.data
                    let msg = res.message
                    if (res.code == 0) {
                        msg = "领取成功"
                        this.$message({
                            message: msg,
                            type: "success"
                        })
                    } else {
                        this.$message({
                            message: msg,
                            type: "warning"
                        })
                    }
                    let list = this.couponList
                    if (res.data.is_exist == 1) {
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].coupon_type_id == item.coupon_type_id) {
                                list[i].useState = 1
                            }
                        }
                    } else {
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].coupon_type_id == item.coupon_type_id) {
                                list[i].useState = 2
                            }
                        }
                    }

                    this.isSub = false
                    this.$forceUpdate()
                })
                .catch((err) => {
                    if (err.message == "您尚未登录，请先进行登录") {
                        this.$router.push("/login")
                    } else {
                        this.$message.error(err.message)
                    }
                    this.isSub = false
                })
        },
        /**
         * 点击优惠券
         */
        couponTap(item, index) {
            if (item.useState == 0) this.receiveCoupon(item, index)
            else this.toGoodsList(item)
        },
        /**
         * 去购买
         */
        toGoodsList(item) {
            if (item.use_scenario != 1) {
                this.$router.push({
                    path: "/list",
                    query: {
                        platformcouponTypeId: item.platformcoupon_type_id
                    }
                })
            } else {
                this.$router.push("/list")
            }
        },
        /**
         * 限时秒杀
         */
        getTimeList() {
            timeList()
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        let time = new Date(res.timestamp * 1000)
                        let currentTimes = time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds()
                        res.data.list.forEach((v, k) => {
                            if (v.seckill_start_time <= currentTimes && currentTimes < v.seckill_end_time) {
                                let seckillId = v.id
                                this.getGoodsList(seckillId)

                                let endTime = parseInt(time.getTime() / 1000) + (v.seckill_end_time - currentTimes)
                                this.seckillTimeMachine = {
                                    currentTime: res.timestamp,
                                    startTime: res.timestamp,
                                    endTime: endTime
                                }
                            }
                        })
                    }
                })
                .catch((err) => {
                    // this.$message.error(err.message)
                })
        },
        /**
         * 秒杀商品
         */
        getGoodsList(id) {
            goodsPage({
                page_size: 0,
                seckill_time_id: id,
                site_id: this.siteId
            })
                .then((res) => {
                    if (res.code == 0 && res.data.list) {
                        this.listData = res.data.list
                    }
                })
                .catch((err) => {})
        },
        /**
         * 换购商品
         */
        exchange(id) {
            exchangePage({
                page_size: 0,
                seckill_id: 1,
                site_id: this.siteId
            })
                .then((res) => {
                    this.exchangelistData = res.list || []
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        exchangegoSku(skuId) {
            this.$router.pushToTab("/sku-" + skuId)
        },
        /**
         * 图片加载失败
         */
        imageError(index) {
            this.listData[index].goods_image = this.defaultGoodsImage
        },
        /**
         * 图片加载失败
         */
        adLeftImageError(index) {
            this.adLeftList[index].goods_image = this.defaultGoodsImage
        },
        /**
         * 图片加载失败
         */
        adRightImageError(index) {
            this.adRightList[index].goods_image = this.defaultGoodsImage
        },
        getFloors() {
            floors()
                .then((res) => {
                    this.floorList = res.data
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        getFloatLayer() {
            floatLayer()
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.floatLayer = res.data
                        if (this.floatLayer.is_show == 1) {
                            this.floatLayer.link = JSON.parse(this.floatLayer.url)
                            // 弹框形式，首次弹出 1，每次弹出 0
                            if (!this.floatLayer.img_url) return
                            var index_popwindow_count = this.$store.state.app.indexFloatLayerNum
                            if (parseInt(this.floatLayer.number) >= 1) {
                                //缓存计数 == 弹出总数   禁止弹出
                                if (index_popwindow_count >= parseInt(this.floatLayer.number)) {
                                    this.floatLayer.is_show_type = false
                                } else {
                                    this.floatLayer.is_show_type = true
                                }
                            } else if (parseInt(this.floatLayer.number) == 0) {
                                this.floatLayer.is_show_type = true
                            }
                        } else {
                            this.floatLayer.is_show_type = false
                        }
                    }
                })
                .catch((err) => err)
        },
        closeFloat() {
            var index_popwindow_count = this.$store.state.app.indexFloatLayerNum
            if (parseInt(this.floatLayer.number) == 0) {
                this.$store.commit("app/SET_FLOAT_LAYER", 0)
            } else if (parseInt(this.floatLayer.number) >= 1 && index_popwindow_count != parseInt(this.floatLayer.number)) {
                var count_num = index_popwindow_count + 1
                this.$store.commit("app/SET_FLOAT_LAYER", count_num)
            } else if (index_popwindow_count == parseInt(this.floatLayer.number)) {
                this.$store.commit("app/SET_FLOAT_LAYER", this.floatLayer.number)
            }
            this.floatLayer.is_show_type = false
            this.$forceUpdate()
            // this.$store.commit("app/SET_FLOAT_LAYER", -1)
        },
        // 监听滚动条
        handleScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

            if (scrollTop >= 680) {
                this.isShow = true
            } else {
                this.isShow = false
            }
        },
        destroyed() {
            // 离开该页面需要移除这个监听的事件，不然会报错
            window.removeEventListener("scroll", this.handleScroll)
        },
        /**
         * 默认搜索类型（goods/shop）
         */
        getDefaultSearchWords() {
            apiDefaultSearchWords({}).then((res) => {
                if (res.code == 0 && res.data.words) {
                    this.defaultSearchWords = res.data.words
                }
            })
        },
        handleCommand(command) {
            this.searchType = command
        },
        search() {
            if (this.searchType == "goods")
                this.$router.push({
                    path: "/list",
                    query: {
                        keyword: this.keyword
                    }
                })
            else
                this.$router.push({
                    path: "/street",
                    query: {
                        keyword: this.keyword
                    }
                })
        }
    }
}
